import { IEvent } from "modules/events/domain/models/IEvent";
import {
  ILoginEventParams,
  ILoginEventResponse,
} from "modules/events/domain/models/ILoginEvent";
import { IEventRepository } from "modules/events/domain/interfaces/IEventRepository";
import { IHttpRepository } from "../../interfaces/IHttpRepository";
import { HttpRepository } from "./_HttpRepository";

export const EventRepository = (): IEventRepository => {
  const httpRepository: IHttpRepository = HttpRepository();

  const getEventsByLocalClienteId = async (
    localClienteId: string
  ): Promise<IEvent[]> => {
    return await httpRepository.getAsync<IEvent[]>(
      `/Event/GetEventByLocalClienteId/${localClienteId}`
    );
  };

  const loginEvent = async (
    params: ILoginEventParams
  ): Promise<ILoginEventResponse> => {
    const query = new URLSearchParams({
      localClienteId: params.localClienteId,
      eventId: params.eventId,
      operadorId: params.operadorId,
      dataEquipamentoUTC: params.dataEquipamentoUTC,
      serial: params.serial,
      version: params.version,
    }).toString();

    const response = await httpRepository.postAsync<
      ILoginEventParams,
      ILoginEventResponse
    >(
      `/v2/SessaoPOS/EnterEvent?${query}`,
      undefined as unknown as ILoginEventParams
    );

    return {
      eventId: response.eventId,
      WorksWithEvents: response.WorksWithEvents ?? false,
    };
  };

  return {
    getEventsByLocalClienteId,
    loginEvent,
  };
};
